
const yp = {
  state: {
  },

  mutations: {
  },

  actions: {
  }
}

export default yp



// WEBPACK FOOTER //
// ./src/store/modules/yp.js